import { FC } from 'react';

import { useSetRecoilState } from 'recoil';

import { Button } from '@shared/components/Button';
import { Icon } from '@shared/components/icons';
import { simpleOpenAtomFamily } from '@shared/state/atom';
import { useId } from 'react-id-generator';

import BugoDetailModal from './BugoDetailModal';

interface IProps {
  feventId: string;
}

const BugoDetailModalOpener: FC<IProps> = ({ feventId }: IProps) => {
  const [id] = useId(1, 'bugoDetailModalOpener');
  const openId = `modal-${id}`;
  const setOpen = useSetRecoilState(simpleOpenAtomFamily(openId));
  const { ChevronRight } = Icon();

  const onClick = () => {
    if (feventId) setOpen(true);
  };

  return (
    <>
      <Button className="rounded-sm p-0.5 shadow-sm" onClick={onClick}>
        <ChevronRight className="wh-6" />
      </Button>
      {feventId && <BugoDetailModal openId={openId} feventId={feventId} />}
    </>
  );
};

export default BugoDetailModalOpener;
